module.exports = __webpack_public_path__ + "static/2-a51ea9d2dcd475da2281c1f1c28c1c04.jpg";